import type { ReactNode } from 'react'
import styles from './Panel.module.css'

interface PanelProps {
    /** Rendered as the panel's label in the top rule. */
    title?: string
    /** Sits opposite the title: counts, units, a control. */
    aside?: ReactNode
    children: ReactNode
    /** Promotes the heading level when a panel is a page section rather than a card. */
    as?: 'section' | 'div'
    /** Layout only -- spacing and placement belong to the caller, not the panel. */
    className?: string
}

/**
 * The structural unit of the whole UI: a boxed region with its label set into
 * the top rule, the way a TUI frames a pane.
 */
export default function Panel({ title, aside, children, as: Tag = 'section', className }: PanelProps) {
    return (
        <Tag className={className ? `${styles.panel} ${className}` : styles.panel}>
            {(title || aside) && (
                <div className={styles.head}>
                    {title && <h2 className={styles.title}>{title}</h2>}
                    {aside && <div className={styles.aside}>{aside}</div>}
                </div>
            )}
            <div className={styles.body}>{children}</div>
        </Tag>
    )
}
